var map = {
	"./gallery_00.jpg": 1918,
	"./gallery_01.jpg": 1919,
	"./gallery_02.jpg": 1920,
	"./gallery_03.jpg": 1921,
	"./gallery_04.jpg": 1922,
	"./gallery_05.jpg": 1923,
	"./gallery_06.jpg": 1924,
	"./gallery_07.jpg": 1925,
	"./gallery_08.jpg": 1926,
	"./gallery_09.jpg": 1927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1917;